// src/config.js
//const API_URL = "http://localhost:5289" // Base URL of your API
//const API_URL = "http://213.199.62.80:93"
//const API_URL = "https://localhost:7235"
const API_URL = "https://apidemo.hrloomer.com"
export default API_URL
